import { LegacyRef } from 'react'

import { Flex, FormLabel, Switch } from '@chakra-ui/react'

interface LabeledSwitchIProps {
  isChecked?: boolean
  onSwitchChange?: (isChecked: boolean) => void
  isDisabled?: boolean
  label?: string
  id: string
  inputRef?: LegacyRef<HTMLInputElement>
}

export const LabeledSwitch = ({
  isChecked = false,
  onSwitchChange,
  label,
  id,
  isDisabled,
  inputRef = null,
}: LabeledSwitchIProps) => {
  const handleToggle = () => {
    if (onSwitchChange) {
      onSwitchChange(!isChecked)
    }
  }

  return (
    <Flex alignItems='center' justifyContent='space-between' mb={2}>
      {label && (
        <FormLabel htmlFor={id} mr='0'>
          {label}
        </FormLabel>
      )}
      <Switch
        id={id}
        isChecked={isChecked}
        isDisabled={isDisabled}
        name={id}
        onChange={handleToggle}
        ref={inputRef}
        sx={{
          '.chakra-switch__track': {
            bg: isChecked
              ? 'components.switch.active'
              : 'components.switch.inactive',
          },
        }}
      />
    </Flex>
  )
}
